import React from 'react'
import { Container } from 'react-bootstrap'
import withStyles from 'isomorphic-style-loader/withStyles';
import Skeleton from '../../../Common/Skeleton/Skeleton'
import CitySectionSwiperSkeleton from './CitySectionSwiperSkeleton/CitySectionSwiperSkeleton';
import s from './CitySectionSkeleton.css'


function CitySectionSkeleton() {

    return (
        <div className={s.categorySkeletonContainer}>
            <Container>
                <Skeleton className={s.categorySkeletonHeading} />
                <CitySectionSwiperSkeleton />
                <div className={s.categorySkeletonLinkContainer}>
                    <Skeleton className={s.categorySkeletonLink} />
                </div>
            </Container>
        </div>
    )
}

export default withStyles(s)(CitySectionSkeleton);
